const key = 'tc.outreach.claim'
let memory = null

export function captureOutreachClaim () {
  if (typeof window === 'undefined') return
  const query = new URLSearchParams(window.location.search)
  const token = query.get('outreach')
  if (!token || !/^[a-f0-9]{48}$/.test(token)) return
  memory = { token, expires: Date.now() + 7 * 86400000 }
  try { window.sessionStorage.setItem(key, JSON.stringify(memory)) } catch (_) {}
  query.delete('outreach')
  window.history.replaceState(window.history.state, '', window.location.pathname + (query.toString() ? '?' + query.toString() : '') + window.location.hash)
}

export function readOutreachClaim () {
  captureOutreachClaim()
  let saved = memory
  try { saved = JSON.parse(window.sessionStorage.getItem(key)) || memory } catch (_) {}
  return saved && saved.expires > Date.now() && /^[a-f0-9]{48}$/.test(saved.token) ? saved.token : null
}

export function clearOutreachClaim () {
  memory = null
  try { window.sessionStorage.removeItem(key) } catch (_) {}
}

captureOutreachClaim()
